// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as UpdateCustomerConsentsApiModel from "../api-model/UpdateCustomerConsentsApiModel.bs.js";

function apiModelToState(res) {
  return {
          message: res.message
        };
}

function execute(json) {
  var res = DeccoUtils$Catalyst.resolveResult(UpdateCustomerConsentsApiModel.t_decode(json), "UpdateCustomerConsentsEntityMapper.res");
  return {
          message: res.message
        };
}

export {
  apiModelToState ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
